'use client';

import { ReactNode, useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useCartStore } from '@/stores/cart';

interface HomeContentProps {
  /** Default sections rendered by the server (category highlights, brands, blog, etc.) */
  defaultSections: ReactNode;
  /** Sections that always show regardless of vehicle selection (stats, shipping, about) */
  alwaysSections: ReactNode;
}

export function HomeContent({ defaultSections, alwaysSections }: HomeContentProps) {
  const selectedVehicle = useCartStore((state) => state.selectedVehicle);
  const selectedPlate = useCartStore((state) => state.selectedPlate);

  // Prevent hydration mismatch: SSR always renders defaultSections (no localStorage).
  // After mount, we read Zustand (which hydrates from localStorage) and may switch to vehicle view.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Startsidan med vald bil var en egen vy (bilkort, kategorier, populära
  // delar) — "jätteonödig o ett knapptryck till, säljer inte mig något"
  // (ägaren 2026-09-16). Nu går den som har en bil vald direkt till
  // fordonssidan med alla delar. Servern renderar fortfarande den vanliga
  // startsidan (ingen bil i localStorage för sökmotorer), så SEO påverkas inte.
  // Vill man till startsidan utan bil: "Byt fordon" på fordonssidan rensar valet.
  const router = useRouter();
  useEffect(() => {
    if (!mounted || !selectedVehicle) return;
    router.replace(`/fordon/${selectedVehicle.ktype}${selectedPlate ? `?plate=${encodeURIComponent(selectedPlate)}` : ''}`);
  }, [mounted, selectedVehicle, selectedPlate, router]);

  if (mounted && selectedVehicle) {
    // Tomt under omdirigeringen — hjälten ovanför visar redan bilen.
    return <div className="min-h-[40vh]" aria-busy="true" />;
  }

  return (
    <>
      {defaultSections}
      {alwaysSections}
    </>
  );
}
